module.exports = __webpack_public_path__ + "static/img/banner.f359f744.png";